// Turnos completos del chat que deben pasar antes de ofrecer el módulo siguiente. Un rechazo es un clic, sin turno propio.
// Aceptar no espera: el servidor marca la oferta recién al activar el módulo y hasta entonces la tarjeta se oculta con el chat ocupado.
export const ESPERA_TRAS_RESOLVER = { rechazada: 1 };

export const esperaTrasResolver = (resultado) => ESPERA_TRAS_RESOLVER[resultado] ?? 0;

export const esperaTrasTurno = (espera) => Math.max(0, (espera || 0) - 1);

// La oferta solo se dibuja con el recorrido completo, sin una resolución reciente en espera y sin nada en curso en el chat.
export const ofertaAMostrar = ({ miObra, espera = 0, ocupado = false } = {}) => {
  if (ocupado || espera > 0 || !miObra?.onboarding?.completo) return null;
  const oferta = miObra.oferta;
  return oferta?.payload?.titulo && oferta.payload.modulo ? oferta : null;
};

// La primera vez que se dibuja una oferta se avisa al servidor para no repetirla; después no se vuelve a avisar.
export const ofertaNuevaParaRegistrar = (oferta, yaRegistradas = []) => {
  const modulo = oferta?.payload?.modulo;
  return modulo && !yaRegistradas.includes(modulo) ? modulo : null;
};
